import { useState, useEffect } from "react";
import { useOutletContext, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Heart, Calendar, ArrowRight } from "lucide-react";
import PageHero from "./PageHero";

const KennelLitters = () => {
  const { API } = useOutletContext();
  const [litters, setLitters] = useState([]);

  useEffect(() => {
    fetch(`${API}/litters`).then(r => r.json()).then(setLitters);
  }, [API]);

  return (
    <div>
      <PageHero
        breadcrumbs={[{ label: "MIOTY" }]}
        label="MIOTY"
        title="Mioty, które są początkiem nowych historii"
        description="Każdy miot to efekt przemyślanej pracy, dobrze dobranej pary i troskliwej opieki. Od pierwszych dni życia szczenięta są z nami — uczymy je świata, zapewniamy ciepło i socjalizację. Tu znajdziesz informacje o naszych dotychczasowych miotach."
        testId="litters"
      />

      <div className="px-6 md:px-12 py-12 max-w-7xl mx-auto space-y-8">
        {/* Litters from DB */}
        {litters.map((l, i) => {
          const birthDisplay = l.birth_date ? new Date(l.birth_date).toLocaleDateString("pl-PL", { day: "numeric", month: "long", year: "numeric" }) : "";
          return (
            <motion.div key={l.id} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.1 }}
              className="bg-[#1A1A1D] border border-[#D4AF37]/15 hover:border-[#D4AF37]/40 overflow-hidden transition-all duration-500 group"
              data-testid={`litter-card-${l.slug || l.id}`}
            >
              <div className="grid md:grid-cols-[420px_1fr]">
                <div className="aspect-video md:aspect-auto overflow-hidden bg-[#141416] min-h-[280px] gallery-wow" style={{ transform: 'none' }}>
                  {(l.announcement_image || l.image_url) ? (
                    <img src={l.announcement_image || l.image_url} alt={l.name} className="w-full h-full object-cover" />
                  ) : (
                    <div className="w-full h-full flex flex-col items-center justify-center"><Heart className="w-12 h-12 mb-3 text-[#D4AF37]/20" /></div>
                  )}
                  <div className="wow-overlay" />
                </div>
                <div className="p-8 md:p-10 flex flex-col justify-center relative">
                  <div className="absolute -top-20 -right-20 w-60 h-60 bg-[#D4AF37]/[0.06] rounded-full blur-[80px] group-hover:bg-[#D4AF37]/[0.12] transition-all duration-700 pointer-events-none" />
                  {birthDisplay && (
                    <span className="text-[10px] tracking-[0.15em] text-[#D4AF37] border border-[#D4AF37]/25 bg-[#D4AF37]/[0.05] px-4 py-1.5 self-start mb-5 flex items-center gap-1.5">
                      <Calendar className="w-3 h-3" /> {birthDisplay}
                    </span>
                  )}
                  <h2 className="font-serif text-2xl text-[#F5F5F5] group-hover:text-[#D4AF37] transition-colors mb-3">{l.name}</h2>
                  <p className="text-[#B8B8B8]/60 text-sm mb-2 flex items-center gap-2">
                    <Heart className="w-4 h-4 text-[#D4AF37]/40" />
                    {l.mother?.name || "—"} × {l.father?.name || "—"}
                  </p>
                  {l.puppies_info && <p className="text-[#B8B8B8]/40 text-sm mb-6">{l.puppies_info}</p>}
                  <Link to={`/mioty/${l.slug || l.id}`}
                    className="text-xs tracking-[0.15em] text-[#D4AF37] border border-[#D4AF37]/20 px-6 py-2.5 self-start hover:bg-[#D4AF37] hover:text-[#0B0B0D] transition-all duration-300 flex items-center gap-2"
                    data-testid={`litter-link-${l.slug || l.id}`}
                  >ZOBACZ {l.name.toUpperCase()} <ArrowRight className="w-3.5 h-3.5" /></Link>
                </div>
              </div>
            </motion.div>
          );
        })}

        {litters.length === 0 && <p className="text-[#B8B8B8]/30 text-center py-24 text-sm">Brak aktualnych miotów</p>}
      </div>
    </div>
  );
};
export default KennelLitters;
